export default function openHours() {
	let weekHours = $('.openHours__week');

	if (weekHours.length > 0) {
		if (window.innerWidth < 1050 && window.innerWidth > 980) {
			let leftPos = $('.openHours__currentDay').offset();
			weekHours.animate({ scrollLeft: leftPos.left - 70 }, 350);
		} else if (window.innerWidth < 980 && window.innerWidth > 768) {
			let leftPos = $('.openHours__currentDay').offset();
			weekHours.animate({ scrollLeft: leftPos.left - 50 }, 350);
		} else if (window.innerWidth < 768 && window.innerWidth > 650) {
			let leftPos = $('.openHours__currentDay').offset();
			weekHours.animate({ scrollLeft: leftPos.left - 40 }, 350);
		} else if (window.innerWidth < 650 && window.innerWidth > 450) {
			let leftPos = $('.openHours__currentDay').offset();
			weekHours.animate({ scrollLeft: leftPos.left - 35 }, 350);
		} else if (window.innerWidth < 450) {
			let leftPos = $('.openHours__currentDay').offset();
			weekHours.animate({ scrollLeft: leftPos.left - 20 }, 350);
		}
	}
}
